import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { Params } from "../../../types/Types";
import { InvestorProfileData } from "../../../components/Models/InvestorProfileData";

interface PaginatedInvestorResponse {
  investorProfile: InvestorProfileData[];
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
}

export function useGetInvestors({
  enabled = true,
  pageSize = 10,
  page = 1,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ["investors", { pageSize, page }],
    queryFn: async () => {
      const url = getAPIURL(
        `/MuslimInvestProfile/Investor/All?pageNumber=${page}&pageSize=${pageSize}`
      );
      return axiosInstance<PaginatedInvestorResponse>(url).then(
        (res) => res.data
      );
    },
  });
}
